import { render, staticRenderFns } from "./zpxqfb.vue?vue&type=template&id=b3d36424&scoped=true"
import script from "./zpxqfb.vue?vue&type=script&lang=js"
export * from "./zpxqfb.vue?vue&type=script&lang=js"
import style0 from "./zpxqfb.vue?vue&type=style&index=0&id=b3d36424&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d36424",
  null
  
)

export default component.exports